import apiClient from './api.service'

export interface TencentCOSConfig {
  secret_id: string
  secret_key: string
  region: string
  bucket: string
  domain: string
  path_prefix: string
  enabled: boolean
}

export interface WechatMiniProgramConfig {
  appid: string
  secret: string
  mch_id?: string
  enabled: boolean
}

export interface SiteSettings {
  tencent_cos?: {
    value: TencentCOSConfig
    description: string
  }
  [key: string]:
    | {
        value: any
        description: string
      }
    | undefined
}

class SettingsService {
  // 获取所有设置
  async getAllSettings(): Promise<SiteSettings> {
    const response = await apiClient.get<{ success: boolean; data: SiteSettings; message: string }>('/settings')
    if (response.data.success) {
      return response.data.data
    }
    throw new Error(response.data.message || '获取设置失败')
  }

  // 获取单个设置
  async getSetting(key: string): Promise<any> {
    const response = await apiClient.get<{
      success: boolean
      data: { key: string; value: any; description: string }
      message: string
    }>(`/settings/${key}`)
    if (response.data.success) {
      return response.data.data
    }
    throw new Error(response.data.message || '获取设置失败')
  }

  // 更新单个设置
  async updateSetting(key: string, value: any, description?: string): Promise<any> {
    const response = await apiClient.put<{
      success: boolean
      data: { key: string; value: any; description: string }
      message: string
    }>(`/settings/${key}`, {
      value,
      description,
    })
    if (response.data.success) {
      return response.data.data
    }
    throw new Error(response.data.message || '更新设置失败')
  }

  // 批量更新设置
  async updateSettings(settings: Record<string, { value: any; description?: string }>): Promise<any[]> {
    const response = await apiClient.put<{ success: boolean; data: any[]; message: string }>('/settings', {
      settings,
    })
    if (response.data.success) {
      return response.data.data
    }
    throw new Error(response.data.message || '批量更新设置失败')
  }

  // 更新腾讯云COS配置
  async updateTencentCOS(config: TencentCOSConfig): Promise<void> {
    await this.updateSetting('tencent_cos', config, '腾讯云对象存储配置')
  }

  // 更新微信小程序配置（保存到 wechat_config）
  async updateWechatMiniProgram(config: WechatMiniProgramConfig): Promise<void> {
    await this.updateSetting('wechat_config', config, '微信小程序配置')
  }
}

export default new SettingsService()
